var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"accordion",class:{'accordion_open': _vm.isOpen}},[_c('div',{staticClass:"accordion__heading",on:{"click":_vm.toggle}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.heading)}})]),(_vm.isOpen)?_c('div',{staticClass:"accordion__content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }